/**
 * The X-Forwarded-Origin header contains the original original requested by the client
 * Used to identify tenant from request hostname
 */
export const X_FORWARDED_ORIGIN = 'x-forwarded-origin';

/**
 * The X-Checkout-ID header contains the checkout ID for checkout-specific operations
 */
export const X_CHECKOUT_ID = 'x-checkout-id';
